import { BotCharacter } from '../characters/bot/bot';
import { KingCharacter } from '../characters/king/king';
import { NecromancerCharacter } from '../characters/necromancer/necromancer';
import { TacticianCharacter } from '../characters/tactician/tactician';

export const RECRUTABLE_CHARACTERS = [ KingCharacter, NecromancerCharacter, TacticianCharacter ];
export const AVAILABLE_CHARACTERS = [ ...RECRUTABLE_CHARACTERS, BotCharacter ]